import { fatal, readCookie } from '../utils';

let managers: { extensionManager: AppTypes.ExtensionManager } | null = null;

export function initRoots(extensionManager: AppTypes.ExtensionManager): void {
  managers = { extensionManager };
}

function requireExtensionManager(): AppTypes.ExtensionManager {
  if (!managers?.extensionManager) {
    fatal('config/roots used before initRoots() ran in preRegistration');
  }
  return managers.extensionManager;
}

function requireAppConfigPath(path: string): string {
  const appConfig = requireExtensionManager().appConfig as Record<string, any>;
  const value = path.split('.').reduce((node, key) => node?.[key], appConfig);

  if (typeof value !== 'string' || !value) {
    fatal(
      `appConfig.${path} is not set. The active app config must carry an ` +
        `implementation.environmentManagement block — see sycai-local.js.`
    );
  }

  return value;
}

export function getAuthRoot(): string {
  return requireAppConfigPath('implementation.environmentManagement.server.baseUrl').replace(
    /\/+$/,
    ''
  );
}

export function getLoginUrl(): string {
  return requireAppConfigPath('implementation.environmentManagement.client.loginUrl');
}

export function getViewerRoot(): string {
  const viewerUrl = readCookie('viewerUrl');

  const root = viewerUrl?.trim().replace(/\/+$/, '');

  if (!root) {
    fatal('the viewerUrl cookie is absent or empty');
  }

  return root;
}

function resolvePacsRoot(): string | undefined {
  if (!managers?.extensionManager) {
    return undefined;
  }

  const dataSource = managers.extensionManager.getActiveDataSource()?.[0];
  const wadoRoot = dataSource?.getConfig?.()?.wadoRoot;

  if (!wadoRoot) {
    return undefined;
  }

  return String(wadoRoot).replace(/\/dicom-web\/?$/, '');
}

export function getPacsRoot(): string {
  const extensionManager = requireExtensionManager();
  const root = resolvePacsRoot();

  if (!root) {
    fatal(`active data source "${extensionManager.activeDataSourceName}" reports no wadoRoot`);
  }

  return root;
}

export function tryGetPacsRoot(): string | undefined {
  return resolvePacsRoot();
}
